import React from 'react';
import ModalLayout from "@layouts/modal";
import InvestmentForm from "./form";

const InvestModal = ({city_id, show, setShow, className, isBadeSaba = false, event_section, event_view, event_position, is_popup = false}) => {

    return (
        <ModalLayout show={show} setShow={setShow} className={(className ?? '')} modalDialogClass="modal-sm" dialogBodyClassName="px-0">
            <InvestmentForm
                show={show}
                city_id={city_id}
                isBadeSaba={isBadeSaba}
                event_section={event_section}
                event_view={event_view}
                event_position={event_position}
                is_popup={is_popup}
            />
        </ModalLayout>
    );
};

export default InvestModal;

// styles
